<template>
  <div
    :style="{
      backgroundColor: section.styles.backgroundColor || '#10b981',
      padding: section.styles.padding || '72px 20px',
      textAlign: section.styles.textAlign || 'center',
      color: section.styles.textColor || '#ffffff',
    }"
  >
    <div class="max-w-3xl mx-auto">
      <h2 v-if="section.content.title" class="text-3xl md:text-4xl font-bold mb-4">{{ section.content.title }}</h2>
      <p v-if="section.content.subtitle" class="text-lg opacity-90 mb-8">{{ section.content.subtitle }}</p>
      <a
        v-if="section.content.ctaText"
        :href="section.content.ctaLink || '#'"
        class="inline-block rounded-lg bg-white px-8 py-3 font-semibold text-gray-900 shadow-md hover:shadow-lg transition-shadow"
      >
        {{ section.content.ctaText }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section: { type: Object, required: true },
    preview: { type: Boolean, default: false },
  },
}
</script>
